import { ModelBase } from 'store/model-base';
import { NowSimActivationStatus } from 'now-mobile/constants';


export class NowEsimActivationStatus extends ModelBase {
    public static storeName: string = 'nowEsimActivationStatus';

    public additionalInfo: NowAdditionalInfo;
    public errorInfo: ApiError;
    public orderId: string;
    public orderKey: string;
    public status: string;
    public provisioningStatus: string;

    public get isFailed(): boolean {
        return this.status === NowSimActivationStatus.FAILED;
    }

    public get isCompleted(): boolean {
        return this.status === NowSimActivationStatus.COMPLETED;
    }

    public static create<T extends ModelBase>(initData: object): T {
        const esimActivationStatus: NowEsimActivationStatus = super.create<NowEsimActivationStatus>(initData);
        
        return super.create<T>(esimActivationStatus);    
    }
}
